/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  eqeqeq,
  func-names,
  import/no-extraneous-dependencies,
  max-len,
  no-restricted-syntax,
  react/no-find-dom-node,
  react/prop-types
*/
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import watchAppNotifierMixin from 'common/components/mixins/watch-app-notifier';
import HfReactHelper from 'common/utils/hf-react-helper';
import classNames from 'classnames';
import createReactClass from 'create-react-class';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import HelloModal from 'common/components/hello-modal';
import Constants from 'hellosign/components/home/top-bar-menu/marketing-nav-bar/top-bar-data';
import SignatureRequestsTour from 'hellospa/components/signature-requests/tour';
import { IconButton } from 'dig-components/buttons';
import { UIIcon } from 'dig-components/icons';
import { CloseLine } from 'dig-components/icons/src';
import GlobalNav from 'hellospa/components/global-nav';
import Logo from '../logo-v2';
import WinkLink from './winklink';

export const FILTERS = {
  documentsbulk: 'bulk',
  documentsallteam: 'all_team',
  documentsoutforsignature: 'out_for_signature',
  documentsawaiting: 'awaiting_my_signature',
  documentscompleted: 'completed',
  documentsdeclined: 'declined',
  documentstemplates: 'template',
  documentstemplatelinks: 'template_link',
  documentsdrafts: 'draft',
  documentssent: 'sent',
  documentsreceived: 'received',
  documentsdeletedforeveryone: 'deleted_for_everyone',
};

const messages = defineMessages({
  allTeamFax: { id: '', description: 'webapp, homepage sidebar link to list of team faxes', defaultMessage: 'All team faxes' },
  allTeamDocs: { id: '', description: 'webapp, homepage sidebar link to list of team documents', defaultMessage: 'All team documents' },
  bulkSend: { id: '', description: 'webapp, homepage sidebar bulkSend link', defaultMessage: 'Bulk send' },
  bulkSendUpgradeModalTitle: { id: '', description: 'Upsell modal that appears in webapp, when users click on homepage sidebar bulkSend link', defaultMessage: 'Upgrade for bulk send' },
  bulkSendUpgradeModalClose: { id: '', description: 'Close button in upsell modal that appears in webapp, when users click on homepage sidebar bulkSend link', defaultMessage: 'Close' },
  bulkSendUpgradeModalContact: { id: '', description: 'Contact-us button in upsell modal that appears in webapp, when users click on homepage sidebar bulkSend link. When clicked, will send users to a form that sales will receive', defaultMessage: 'Contact us' },
  outForSignature: { id: '', description: 'webapp, homepage sidebar outForSignature link', defaultMessage: 'Out for signature' },
  awaitingMySignature: { id: '', description: 'webapp, homepage sidebar awaitingMySignature link', defaultMessage: 'Awaiting my signature' },
  completed: { id: '', description: 'webapp, homepage sidebar completed link', defaultMessage: 'Completed' },
  declined: { id: '', description: 'webapp, homepage sidebar declined link', defaultMessage: 'Declined' },
  templates: { id: '', description: 'webapp, homepage sidebar templates link', defaultMessage: 'Templates' },
  templateLinks: { id: '', description: 'webapp, homepage sidebar templateLinks link', defaultMessage: 'Template links' },
  draft: { id: '', description: 'webapp, homepage sidebar draft link', defaultMessage: 'Draft' },
  sent: { id: '', description: 'webapp, homepage sidebar link to sent documents', defaultMessage: 'Sent' },
  received: { id: '', description: 'webapp, homepage sidebar link to received documents', defaultMessage: 'Received' },
  deletedForEveryone: { id: '', description: 'webapp, homepage sidebar link to deleted documents', defaultMessage: 'Deleted for everyone' },
  closeSidebar: { id: '', description: 'title text for a button which closes the sidebar when pressed', defaultMessage: 'Close sidebar' },
  team: { id: '', description: 'webapp, homepage sidebar link to team page', defaultMessage: 'Team' },
  documents: { id: '', description: 'webapp, homepage sidebar link to Documents page', defaultMessage: 'Documents' },
  integrations: { id: '', description: 'webapp, homepage sidebar link to Integrations page', defaultMessage: 'Integrations' },
  signDocuments: { id: '', description: 'webapp, homepage sidebar link to Sign Documets', defaultMessage: 'Sign Documents' },
});

// In-app left side menu
const AppLeftMenu = createReactClass({

  mixins: [watchAppNotifierMixin],

  propTypes: {
    isBackdropGlobalComponents: PropTypes.bool, // TODO use rebrand HOC when available
    siteCode: PropTypes.string.isRequired, // S or F
    pageSize: PropTypes.number, // List size
    searchBackend: PropTypes.string, // Type of search backend to use
    activeItemId: PropTypes.string, // Menu item currently active
    emailAddress: PropTypes.string.isRequired, // Email address for the current user
    faxNumbers: PropTypes.array, // List of fax numbers
    name: PropTypes.string, // Name of the user
    canAccessBulkSendUI: PropTypes.bool.isRequired,
    canAccessAdminConsole: PropTypes.bool,
    canAccessTemplateConverter: PropTypes.bool,
    canAccessTemplates: PropTypes.bool,
    intl: PropTypes.object,
    isTemplatePageRedesign: PropTypes.bool,
    showLeftNavWinkExperiment: PropTypes.string, // 'control', 'V1' or 'V2'
  },


  getInitialState() {

    const isHf = HfReactHelper.HfSites.isHelloFax(this.props.siteCode);
    const defaultItemId = isHf ? 'sendfax' : 'signdocs';
    let activeItemId = (this.props.activeItemId || defaultItemId);

    // Convert filters to section item ref
    for (const k in FILTERS) {
      if (FILTERS[k] === activeItemId) {
        activeItemId = k;
        break;
      }
    }

    return {
      activeItemId,
      faxLines: this.props.app.user.getFaxLines(),
      isOpenBulksendUpsellModal: false,
    };
  },

  componentDidMount() {

    const root = $(ReactDOM.findDOMNode(this));
    const self = this;

    $('.m-app-leftmenu--section--title > a, .m-app-leftmenu--section--item > a', root).click(function (evt) {

      if (evt.target.tagName === 'A' || evt.target.parentNode.tagName === 'A') {
        return;
      }

      evt.preventDefault();

      const el = $(this);
      let itemId = el.attr('id');

      if (!itemId) {
        itemId = el.parent().attr('id');
      }

      self.setState({
        activeItemId: itemId,
      });
    });
  },

  getItemClassName(sectionName, isItem) {
    let s = `m-app-leftmenu--section${isItem ? '--item' : ''}`;
    if ((sectionName === 'signdocs' && $.inArray(this.state.activeItemId, ['signjustme', 'signmeandothers', 'signjustothers']) >= 0)
      || (sectionName === 'templates' && $.inArray(this.state.activeItemId, ['createtemplate', 'createtemplatelink', 'documentstemplatelinks', 'documentstemplates']) >= 0)
      || ((sectionName === 'documents' && $.inArray(this.state.activeItemId, ['documentstemplatelinks', 'documentstemplates']) < 0 && $.inArray(this.state.activeItemId, Object.keys(FILTERS)) >= 0))) {
      s += ' is-expanded';
    } else if (this.state.activeItemId === sectionName) {
      s += ' is-active';
    }
    return s;
  },

  makeFilter(id, label, dotUrl = null) {

    const params = [`filter=${FILTERS[id]}`];
    if (this.props.searchBackend) {
      params.push(`search_backend=${this.props.searchBackend}`);
    }
    if (this.props.pageSize) {
      params.push(`page_size=${this.props.pageSize}`);
    }

    const site = HfReactHelper.HfSites.getSite(this.props.siteCode);
    const url = HfReactHelper.urlHelper(`home/manage?${params.join('&')}`, site);

    return (
      <div id={id} className={this.getItemClassName(id, true)}>
        <span className={'m-app-leftmenu--section--item--dot'}>
          { dotUrl && <img src={dotUrl} /> }
        </span>
        <a href={url}>{ label }</a>
      </div>
    );
  },

  onSidebarClose() {
    document.body.classList.remove('responsive-layout__sidebar-open');
  },

  render() {
    const { intl, isSpa } = this.props;
    const isHf = HfReactHelper.HfSites.isHelloFax(this.props.siteCode);
    let templates;
    let sendFax;
    let recvFax;
    let getFreePages;
    let signDocs;
    let bulkSend;
    let faxNumbers;
    let manageTeamLink;
    let templateConverterLink;

    const site = HfReactHelper.HfSites.getSite(this.props.siteCode);
    const teamUrl = HfReactHelper.urlHelper('home/team', site);
    const createTemplateUrl = HfReactHelper.urlHelper('home/createTemplate', site);
    const createLinkUrl = HfReactHelper.urlHelper('home/createReusableLink', site);
    const sendFaxUrl = HfReactHelper.urlHelper('home/index', site);
    const recvFaxUrl = HfReactHelper.urlHelper('home/upgrade', site);
    const freePagesUrl = HfReactHelper.urlHelper('account/gettingStarted', site);
    const useTemplateUrl = HfReactHelper.urlHelper('home/manage?filter=template', site);
    const useLinkUrl = HfReactHelper.urlHelper('home/manage?filter=template_link', site);
    const justOthersUrl = HfReactHelper.urlHelper('home/request', site);
    const bulkSendPrepAndSendUrl = HfReactHelper.urlHelper('prep-and-send/new/13', site);
    const templateUrl = HfReactHelper.urlHelper('home/createReusableDocs', site);
    const docsUrl = HfReactHelper.urlHelper('home/manage', site);
    const integrationsUrl = HfReactHelper.urlHelper('home/myAccount?current_tab=integrations', site);
    const templateConverterUrl = HfReactHelper.urlHelper('template/converter', site);

    let documentsName = <FormattedMessage id="" description="webapp, homepage sidebar docs link" defaultMessage="Documents" />;
    let qaAttribute = '';

    if (isHf) {

      documentsName = <FormattedMessage id="" description="webapp, homepage sidebar faxes link" defaultMessage="Faxes" />;

      sendFax = (
        <div id='sendfax' className={this.getItemClassName('sendfax')}>
          <div className='m-app-leftmenu--section--title'>
            <a href={sendFaxUrl}>
              <span>
                <FormattedMessage
                  id=''
                  description='webapp, homepage sidebar, link to send a fax'
                  defaultMessage='Send a fax' />
              </span>
            </a>
          </div>
        </div>
      );

      if (this.props.showUpgradeButton == true) {
        recvFax = (
          <div id='recvfax' className={this.getItemClassName('recvfax')}>
            <div className='m-app-leftmenu--section--title'>
              <a href={recvFaxUrl}>
                <span>
                  <FormattedMessage
                    id=''
                    description='webapp, homepage sidebar, link to receive fax app flow'
                    defaultMessage='Receive faxes' />
                </span>
              </a>
            </div>
          </div>
        );
      } else {
        recvFax = '';
      }

      signDocs = (
        <div id='signdocs' data-qa-ref="sign-documents-left-menu" className={this.getItemClassName('signdocs')}>
          <div className='m-app-leftmenu--section--title'>
            <a href={justOthersUrl}>
              <span>
                {intl.formatMessage(messages.signDocuments)}
              </span>
            </a>
          </div>
        </div>
      );

      getFreePages = (
        <div id='getfreepages' className={`l-margin-t-50 ${this.getItemClassName('getfreepages')}`}>
          <div className='m-app-leftmenu--section--title'>
            <a href={freePagesUrl}>
              <span>
                <FormattedMessage
                  id=''
                  description='webapp, homepage sidebar, link to offer pages where user can get free pages after completing offer terms'
                  defaultMessage='Get free pages' />
              </span>
            </a>
          </div>
        </div>
      );

      if (this.state.faxLines && this.state.faxLines.length > 0) {

        const numbers = this.state.faxLines.map((faxLine, index) => {
          return <div key={index} className='m-app-leftmenu--fax-numbers--list--item'>{ faxLine.number }</div>;
        });

        const listClasses = classNames({
          'm-app-leftmenu--fax-numbers--list': true,
          'is-scrollable': (this.state.faxLines.length > 12),
        });

        faxNumbers = (
          <div className='m-app-leftmenu--fax-numbers'>
            <div className='m-app-leftmenu--fax-numbers--title'>
              <FormattedMessage
                id=''
                description='webapp, homepage sidebar, header for list of fax numbers under account'
                defaultMessage='{faxLines, plural, one {<upper>your fax number</upper>} other {<upper>your fax numbers</upper>}}'
                values={{ faxLines: this.state.faxLines.length, upper: (...chunks) => (chunks[0].toLocaleUpperCase(intl.locale)) }} />
            </div>
            <div className={listClasses}>
              { numbers }
            </div>
          </div>
        );
      }

    } else {
      const signDocsMenuItems = null;
      signDocs = (
        <div id='signdocs' data-qa-ref="sign-documents-left-menu" className={this.getItemClassName('signdocs')}>
          <div className='m-app-leftmenu--section--title'>
            { (this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
              ? <WinkLink
                  isActive={this.state.activeItemId === 'signdocs'}
                  linkUrl={justOthersUrl}
                  title={intl.formatMessage(messages.signDocuments)}
                  showUpgrade={false}
                  currentVariation={this.props.showLeftNavWinkExperiment} />
              : <a href={justOthersUrl}>
                <span>
                  {intl.formatMessage(messages.signDocuments)}
                </span>
              </a>
             }
          </div>
          {signDocsMenuItems}
        </div>
      );
      const closeBulkSendModal = () => this.setState({ isOpenBulksendUpsellModal: false });
      const openBulkSendModal = () => this.setState({ isOpenBulksendUpsellModal: true });

      bulkSend = (
        <React.Fragment>
          <div id='signbulksend' data-qa-ref="bulk-send" className={this.getItemClassName('signbulksend')}>
            <div className='m-app-leftmenu--section--title'>
              { (this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
                ? <WinkLink
                    isActive={this.state.activeItemId === 'signbulksend'}
                    linkUrl={this.props.canAccessBulkSendUI ? bulkSendPrepAndSendUrl : '#'}
                    title={intl.formatMessage(messages.bulkSend)}
                    showUpgrade={!this.props.canAccessBulkSendUI}
                    currentVariation={this.props.showLeftNavWinkExperiment}
                    onClick={this.props.canAccessBulkSendUI ? null : openBulkSendModal} />
                : <a href={this.props.canAccessBulkSendUI ? bulkSendPrepAndSendUrl : '#'}
                    onClick={this.props.canAccessBulkSendUI ? null : openBulkSendModal}
                >
                  <FormattedMessage id="" description="webapp, homepage sidebar bulk send link" defaultMessage="Bulk send" />
                </a>
              }
            </div>
          </div>
          <HelloModal
            isOpen={this.state.isOpenBulksendUpsellModal}
            onRequestClose={closeBulkSendModal}
            contentLabel={intl.formatMessage(messages.bulkSendUpgradeModalTitle)}
            showCloseIcon={true}
            buttons={[
              {
                type: 'secondary',
                text: intl.formatMessage(messages.bulkSendUpgradeModalClose),
                onClick: closeBulkSendModal,
              },
              {
                type: 'primary',
                text: intl.formatMessage(messages.bulkSendUpgradeModalContact),
                buttonLink: Constants.contactUsUrl.url,
                openInNewWindow: true,
              },
            ]}
          >
            <FormattedMessage
              id=''
              description='text upselling bulk send when a non Enterprise Plus customer clicks on bulk send'
              defaultMessage='Bulk send is the easiest way to send a single-signer template to many people all at once.
              Contact us to learn more and upgrade your plan.' />
          </HelloModal>
        </React.Fragment>
      );

      templates = (
        <div id='templates' data-qa-ref="templates" className={this.getItemClassName('templates')}>
          <div className='m-app-leftmenu--section--title m-app-leftmenu--templates'>
            { (this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
              ? <WinkLink isActive={this.state.activeItemId === 'templates'}
                  linkUrl={templateUrl}
                  title={intl.formatMessage(messages.templates)}
                  showUpgrade={!this.props.canAccessTemplates}
                  currentVariation={this.props.showLeftNavWinkExperiment} />
              : <a href={templateUrl} ><span><FormattedMessage id="" description="webapp, homepage sidebar templates link" defaultMessage="Templates" /></span></a>
            }
          </div>
          { !this.props.isTemplatePageRedesign
            ? <div className='m-app-leftmenu--section--items'>
              <div id='createtemplate' className={this.getItemClassName('createtemplate', true)}>
                <a href={createTemplateUrl} data-qa-ref="create-template">
                  <FormattedMessage id="" description="webapp, homepage sidebar create template link" defaultMessage="Create template" />
                </a>
              </div>
              <div id='createtemplatelink' className={this.getItemClassName('createtemplatelink', true)}>
                <a href={createLinkUrl} data-qa-ref="create-template-link">
                  <FormattedMessage id="" description="webapp, homepage sidebar create link link" defaultMessage="Create link" />
                </a>
              </div>
              <div id='documentstemplates' className={this.getItemClassName('documentstemplates', true)}>
                <a href={useTemplateUrl} data-qa-ref="use-template" >
                  <FormattedMessage id="" description="webapp, homepage sidebar use template link" defaultMessage="Templates" />
                </a>
              </div>
              <div id='documentstemplatelinks' className={this.getItemClassName('documentstemplatelinks', true)}>
                <a href={useLinkUrl} data-qa-ref="use-link">
                  <FormattedMessage id="" description="webapp, homepage sidebar use link link" defaultMessage="Template links" />
                </a>
              </div>
            </div>
            : ''
          }
        </div>
      );

      qaAttribute = 'documents-left-menu';

      if (this.props.canAccessTemplateConverter) {
        templateConverterLink = (
          <div id='templateconverter' className={this.getItemClassName('templateconverter')}>
            <div className='m-app-leftmenu--section--title m-app-leftmenu--template-converter'>
              <a href={templateConverterUrl}>
                <span>
                  <FormattedMessage id="" description="webapp, homepage sidebar template converter link" defaultMessage="Template Converter" />
                </span>
              </a>
              <span className='m-app-leftmenu--icon--beta'>
                <FormattedMessage id="" description="webapp, homepage sidebar beta flag" defaultMessage="Beta" />
              </span>
            </div>
          </div>
        );
      }
    }

    if (!this.props.canAccessAdminConsole) {
      manageTeamLink = (
        <div id='manageteam' className={this.getItemClassName('manageteam')}>
          <div className='m-app-leftmenu--section--title m-app-leftmenu--team'>
            { (this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
              ? <WinkLink isActive={this.state.activeItemId === 'manageteam'}
                  linkUrl={teamUrl}
                  title={intl.formatMessage(messages.team)}
                  showUpgrade={!this.props.canAccessAdminConsole}
                  currentVariation={this.props.showLeftNavWinkExperiment} />
              : <a href={teamUrl}><span><FormattedMessage id="" description="webapp, homepage sidebar team link" defaultMessage="Team" /></span></a>
            }
          </div>
        </div>
      );
    }

    const documents = (
      <div id='documents' data-qa-ref={qaAttribute} className={this.getItemClassName('documents')}>
        <div className='m-app-leftmenu--section--title m-app-leftmenu--documents'>
          { (this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
            ? <WinkLink
                linkUrl={docsUrl}
                title={intl.formatMessage(messages.documents)}
                currentVariation={this.props.showLeftNavWinkExperiment}
                isActive={this.state.activeItemId === 'documents'}
                showUpgrade={false} />
            : <a href={docsUrl}>
              <span
                data-tour-item={SignatureRequestsTour.steps.intro}

                // This fixes an issue with Safari tethering the Tooltip too
                // far from the element. This is only needed so long as the above
                // tour is applied.
                style={{ display: 'inline-block', paddingRight: '6px' }}
              >
                {documentsName}
              </span>
            </a>
          }
        </div>
      </div>
    );

    const integrations = ((this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
      ? <div id='manage_integrations' data-qa-ref="integrations" className={this.getItemClassName('manage_integrations')}>
        <div className='m-app-leftmenu--section--title m-app-leftmenu--integrations'>
          <WinkLink isActive={this.state.activeItemId === 'manage_integrations'}
            linkUrl={integrationsUrl}
            title={intl.formatMessage(messages.integrations)}
            showUpgrade={false}
            currentVariation={this.props.showLeftNavWinkExperiment} />
        </div>
      </div>
      : <div id='manage_integrations' data-qa-ref="integrations" className={this.getItemClassName('manage_integrations')}>
        <div className='m-app-leftmenu--section--title m-app-leftmenu--integrations'>
          <a href={integrationsUrl}><span><FormattedMessage id="" description="webapp, homepage sidebar integration link" defaultMessage="Integrations" /></span></a>
        </div>
      </div>
    );

    const layoutOrder = ((this.props.showLeftNavWinkExperiment === 'V1' || this.props.showLeftNavWinkExperiment === 'V2')
      ? <div>
        { documents }
        {isSpa && (
          <SignatureRequestsTour />
        )}
        { integrations }
        { templates }
        { bulkSend }
        { manageTeamLink }
      </div>
      : <div>
        { bulkSend }
        { templates }
        { documents }
        {isSpa && (
          <SignatureRequestsTour />
        )}
        { manageTeamLink }
        { integrations }
      </div>
    );

    const res = (
      <div className='m-app-leftmenu'>
        <div className="m-app-leftmenu--section--logo-container">
          <Logo
            className="m-app-leftmenu--logo"
            variant="glyph"
            siteCode={this.props.siteCode} />
          <IconButton
            onClick={this.onSidebarClose}
            title={intl.formatMessage(messages.closeSidebar)}
            data-qa-ref="sidebar-close"
          >
            <UIIcon src={CloseLine} />
          </IconButton>
        </div>
        { sendFax }
        { recvFax }
        { signDocs }
        { layoutOrder }

        { templateConverterLink }

        { getFreePages }

        { faxNumbers }

        <div className="m-app-leftmenu--screen" />
      </div>
    );

    return res;
  },

});

class MaybeRebrandGlobalNav extends React.Component {
  componentDidMount() {
    this.props.app.notifier.push(this);
  }

  // See src/hellospa/components/signer-signature-document/index.jsx#L426
  notify() {
    this.forceUpdate();
  }

  render() {
    if (this.props.isBackdropGlobalComponents) {
      return <GlobalNav {...this.props} />;
    } else {
      return <AppLeftMenu {...this.props} />;
    }
  }
}

export default injectIntl(MaybeRebrandGlobalNav);
